import { useRef, useState, useEffect } from "react";
import SelectRoleNavigation from "../SelectRoleNavigation";

export default function SalesStepOne({ handleIncrement, num }) {
  const ref = useRef();
  const [fileName, setFileName] = useState("Upload");
  const [isDisabled, setIsDisabled] = useState(true);
  const [linkedinError, setLinkedinError] = useState(""); // LinkedIn validation error
  const [formData, setFormData] = useState({
    current_role: "",
    phone: "",
    linkedin_url: "",
    // profile_image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "linkedin_url") {
      const urlPattern = /^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/i;
      if (!urlPattern.test(value)) {
        setLinkedinError("Enter a valid LinkedIn profile URL");
      } else {
        setLinkedinError("");
      }
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFile = () => {
    const file = ref.current.files[0];

    const maxSize = 2 * 1024 * 1024;

    if (file && file.size > maxSize) {
      alert("File must be under 2MB");
      ref.current.value = "";
      return;
    }

    setFileName(file ? file.name : "Upload");
    setFormData((prev) => ({ ...prev, profile_image: file }));
  };

  useEffect(() => {
    const allFilled =
      Object.values(formData).every((val) => val && val !== "") &&
      !linkedinError;

    setIsDisabled(!allFilled);
  }, [formData, linkedinError]);

  return (
    <>
      <SelectRoleNavigation
        title="Add your current role and contact details"
        text=""
        currentStep={num}
        handleIncrement={handleIncrement}
        validationButton={isDisabled}
      />
      <div className="container">
        <div className="sales-engineer-step-one">
          <div className="form-group">
            <label>Current Role</label>
            <input
              type="text"
              name="current_role"
              placeholder="ex: Project manager"
              value={formData.current_role}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input
              type="tel"
              name="phone"
              placeholder="0"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>LinkedIn Profile</label>
            <input
              type="url"
              name="linkedin_url"
              placeholder="Enter LinkedIn Profile URL"
              value={formData.linkedin_url}
              onChange={handleChange}
            />
            {linkedinError && <p className="error-message">{linkedinError}</p>}{" "}
          </div>
          {/* <div className="form-group file-upload">
            <label>
              Upload your avatar
              <input
                onChange={handleFile}
                ref={ref}
                type="file"
                name="profile_image"
                accept=".jpg, .jpeg, .png"
              />
              <span>{fileName}</span>
            </label>
            <p>In JPG or PNG format not bigger than 2MB</p>
          </div> */}
        </div>
      </div>
    </>
  );
}
